module.exports = __SPARKY_LIBS__.PanWDSReactFiltersV6;